import { render } from "./HR_Employee_Dialog.vue?vue&type=template&id=ab2c5cb4&scoped=true&ts=true"
import script from "./HR_Employee_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_Employee_Dialog.vue?vue&type=script&lang=ts"

import "./HR_Employee_Dialog.vue?vue&type=style&index=0&id=ab2c5cb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2c5cb4"]])

export default __exports__